import { useStatsigClient } from '@statsig/react-bindings';

export const useDynamicConfig = (configName: string) => {
  const { client } = useStatsigClient();
  return client.getDynamicConfig(configName);
};
